import DOMPurify from 'dompurify';
import Swiper from 'swiper/swiper-bundle.min';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import bootstrap from 'bootstrap/dist/js/bootstrap';

export default {
  init() {
    const ajax_url = window.sage.ajax_url || false;
    const btn = document.querySelector('.hamburger');
    if(btn) {
      btn.onclick = () => btn.classList.toggle('is-active');
    }

    const back = document.querySelector('.back');
    if(back) {
      back.addEventListener('click', function(e) {
        e.preventDefault();
        window.history.go(-1);
      });
    }

    const el = document.querySelector('.site-overlay');
    if(el) {
      el.onclick = () => btn.classList.toggle('is-active');
    }

    document
    .querySelectorAll('.scroller a[href^="#"]')
    .forEach(trigger => {
      trigger.onclick = function(e) {
        e.preventDefault();
        let hash = this.getAttribute('href');
        let target = document.querySelector(hash);
        let headerOffset = 100;
        let elementPosition = target.offsetTop;
        let offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
        });
      };
    });
    document
    .querySelectorAll('.js-filter')
    .forEach(btn => {
      btn.onclick = function(e) {
        e.preventDefault();
        document.querySelector('.btn-filter--active').classList.remove('btn-filter--active');
        const category = btn.getAttribute('data-category');
        const action = btn.getAttribute('data-action');

        const data = new FormData();
        data.append('action', action);
        data.append('nonce', window.sage.nonce);
        data.append('cat', category);
        const params = new URLSearchParams(Array.from(data)).toString();

        const xhr = new XMLHttpRequest();

        xhr.open('POST', ajax_url, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        xhr.onreadystatechange = function() {
          if(xhr.readyState === XMLHttpRequest.DONE) {
            if(xhr.status === 200) {
              const response = JSON.parse(xhr.response);
              const el = document.querySelector('.m-corsi__items');
              el.innerHTML = DOMPurify.sanitize(response.data, {USE_PROFILES: {html: true}});
            } else {
              console.log('ERROR');
            }
          }
        }
        xhr.send(params);
        this.classList.add('btn-filter--active');
      }
    });

    document
      .querySelectorAll('.js-load-more')
      .forEach(btn => {
        btn.onclick = function(e) {
          e.preventDefault();
          btn.querySelector('.spinner-border').classList.remove('d-none');
          const queryVars   = btn.getAttribute('data-query');
          const template    = btn.getAttribute('data-template');
          const container   = btn.getAttribute('data-container');
          let currentPage   = parseInt(btn.getAttribute('data-current-page'));
          const maxPages    = parseInt(btn.getAttribute('data-max-pages'));
          const data = new FormData();
          data.append('action', 'loadmore');
          data.append('nonce', window.sage.nonce);
          data.append('template', template);
          data.append('query', queryVars);
          data.append('page', currentPage.toString());
          const params = new URLSearchParams(Array.from(data)).toString();
          const xhr = new XMLHttpRequest();
          xhr.open('POST', ajax_url, true);
          xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
          xhr.onreadystatechange = function() {
            if(xhr.readyState === XMLHttpRequest.DONE) {
              btn.querySelector('.spinner-border').classList.add('d-none');
              if(xhr.status === 200) {
                const response = JSON.parse(xhr.response);
                const el = document.querySelector(container);
                el.insertAdjacentHTML('beforeend', DOMPurify.sanitize(response.data, {USE_PROFILES: {html: true}}))
                btn.setAttribute('data-current-page', ++currentPage);
                if(currentPage >= maxPages) {
                  btn.classList.add('d-none');
                }
              } else {
                console.log('ERROR');
              }
            }
          }
          xhr.send(params);
        }
      });

    let ST;
    // eslint-disable-next-line no-unused-vars
    let IN;
    let contentMarkers;
    let currentPos = 0;

    const hasScrollSlider = !!document.querySelector('.m-scroll-slider');
    const media = window.matchMedia('screen and (max-width: 600px)');

    if(hasScrollSlider) {
      ScrollTrigger.addEventListener('refreshInit', checkSTState);
      console.clear();
      gsap.registerPlugin(ScrollTrigger);
      gsap.defaults({overwrite: 'auto'});
      contentMarkers = gsap.utils.toArray('.contentMarker');
      const total = document.querySelector('.total');
      total.textContent = contentMarkers.length;

      ST = ScrollTrigger.create({
        trigger: '.m-scroll-slider',
        start: 'top top',
        end: 'top 150px',
        endTrigger: '.contentMarkerLast',
        pin: '.right-content',
        scrub: true,
        pinSpacing: false,
        onEnter: setCurrentPosition,
        onUpdate: getCurrentSection,
        markers: false,
      });

      IN = ScrollTrigger.create({
        trigger: '.m-scroll-slider',
        start: 'top top',
        end: 'bottom bottom',
        pin: '.m-scroll-slider--indicator',
        scrub: true,
        pinSpacing: false,
        markers: false,
      });

      // Set up our content behaviors
      contentMarkers.forEach(marker => {
        marker.content = document.querySelector(`#${marker.dataset.markerContent}`);

        if(marker.content.tagName === 'DIV') {
          gsap.set(marker.content, {transformOrigin: 'center'});

          marker.content.enter = function() {
            gsap.fromTo(marker.content, {autoAlpha: 0}, {duration: 0.3, autoAlpha: 1});
          }
        }

        marker.content.leave = function() {
          gsap.to(marker.content, {duration: 0.1, autoAlpha: 0});
        }

      });
      checkSTState();
    }


    //window.addEventListener('resize', setCurrentPosition);
    window.addEventListener('load', setCurrentPosition);

    function setProgressBar(current) {
      const bar = document.querySelector('.m-scroll-slider--percentage');
      gsap.to(bar, {height: 100 * current / contentMarkers.length + '%'});
    }

    function setCurrentPosition() {
      currentPos = scrollY - 200;
    }


    // Handle the updated position
    let lastContent;
    function getCurrentSection() {
      let newContent;
      const currScroll = scrollY;
      const current = document.querySelector('.current');

      // Find the current section
      contentMarkers.forEach(marker => {
        if(currScroll > currentPos + marker.offsetTop) {
          newContent = marker.content;
        }
      });

      // If the current section is different than that last, animate in
      if(newContent
      && (lastContent == null
        || !newContent.isSameNode(lastContent))) {
        // Fade out last section
        if(lastContent) {
          lastContent.leave();
        }
        current.textContent = newContent.getAttribute('data-slide');
        setProgressBar(current.textContent);
        // Animate in new section
        newContent.enter();

        lastContent = newContent;
      }

    }


    function checkSTState() {
      if(media.matches) {
        ST.disable();
      } else {
        ST.enable();
      }
    }

    const verticalSliders = document.querySelectorAll('.slider--vertical');
    const sliders = [];
    let orientation = '';

    verticalSliders.forEach(function(verticalSlider, index) {
      verticalSlider.classList.add('slider--vertical-' + index);
      if(window.innerWidth < 1200) {
        verticalSlider.classList.add('.m-slider--horizontal');
        orientation = 'horizontal';
      } else {
        verticalSlider.classList.add('.m-slider--vertical');
        orientation = 'vertical';
      }
      sliders[index] = new Swiper('.slider--vertical-' + index, {
        direction: orientation,
        slidesToShow: 1,
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    });



    window.addEventListener('resize', setSliderOrientation);
    window.addEventListener('load', setSliderOrientation);
    window.addEventListener('load', openPopup);

    function setSliderOrientation() {
      if(window.innerWidth < 1200) {
        switchVerticalSlider('horizontal');
      } else {
        switchVerticalSlider('vertical');
      }
    }

    function openPopup() {
      const options = {};
      if(document.querySelector('.modal')) {
        const popUp = new bootstrap.Modal(document.querySelector('.modal'), options)
        if(popUp) {
          popUp.show();
        }
      }
    }


    function switchVerticalSlider(orientation) {
      verticalSliders.forEach(function(verticalSlider, index) {
        if(orientation === 'horizontal') {
          verticalSlider.classList.remove('m-slider--vertical');
          verticalSlider.classList.add('m-slider--horizontal');
        } else {
          verticalSlider.classList.remove('m-slider--horizontal');
          verticalSlider.classList.add('m-slider--vertical');
        }
        sliders[index].changeDirection(orientation, true);
      });
    }

    const breakpoint = window.matchMedia( '(min-width:36em)' );

    let mySwiper;

    const breakpointChecker = function() {
      if ( breakpoint.matches === true ) {
        if ( mySwiper !== undefined ) mySwiper.destroy( true, true );
        return;
      } else if ( breakpoint.matches === false ) {
          return enableSwiper();
      }
    };

    const enableSwiper = function() {
      mySwiper = new Swiper ('.swiper-mobile', {
        loop: true,
        slidesToShow: 1,
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
  
      });
  
    };

    breakpoint.addListener(breakpointChecker);
    // kickstart
    breakpointChecker();

    document.addEventListener( 'wpcf7mailsent', function( event ) {
      window.dataLayer = window.dataLayer || [];
      if(event.detail.contactFormId == '8845') {
        console.log('track software');
        // eslint-disable-next-line
        dataLayer.push({
          'event': 'formSoftware',
        });
      }
      if(event.detail.contactFormId == '16136') {
        console.log('track bia');
        // eslint-disable-next-line
        dataLayer.push({
          'event': 'formBia',
        });
      }
     }); 

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js